import { apiService as Service } from '@/services/service'

const url = `api/${import.meta.env.VITE_API_VERSION}/settings`

export const themeService = {
	get: () => Service.get<Api.ClientSetting>({ url }),
	getLogo: () =>
		Service.get({
			url: `${url}/logo`,
			responseType: 'arraybuffer',
		}).then(async ({ data }) => {
			return data
		}),
}

export default themeService
